(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-about"] && !Shopify.designMode) return;
  try {
    
(function () {
  var rail = document.getElementById('nb-tl-rail');
  if (!rail) return;
  var prev = document.getElementById('nb-tl-prev');
  var next = document.getElementById('nb-tl-next');

  function step() {
    var card = rail.querySelector('.nb-tl-item');
    var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 24;
    return card ? card.offsetWidth + gap : 360;
  }
  function update() {
    if (!prev || !next) return;
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  }
  if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  rail.addEventListener('scroll', update, { passive: true });
  update();

  // drag / swipe to scroll (mouse + touch)
  var down = false, startX = 0, startScroll = 0, moved = false;
  rail.addEventListener('pointerdown', function (e) {
    down = true; moved = false; startX = e.clientX; startScroll = rail.scrollLeft;
    rail.setPointerCapture(e.pointerId);
  });
  rail.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - startX;
    if (Math.abs(dx) > 4) { moved = true; rail.classList.add('is-dragging'); }
    rail.scrollLeft = startScroll - dx;
  });
  function end() { down = false; rail.classList.remove('is-dragging'); update(); }
  rail.addEventListener('pointerup', end);
  rail.addEventListener('pointercancel', end);
  rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

  // horizontal wheel support
  rail.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) { rail.scrollLeft += e.deltaY; e.preventDefault(); }
  }, { passive: false });

  // keyboard arrows
  rail.setAttribute('tabindex', '0');
  rail.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); rail.scrollBy({ left: step(), behavior: 'smooth' }); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); rail.scrollBy({ left: -step(), behavior: 'smooth' }); }
    else if (e.key === 'Home') { e.preventDefault(); rail.scrollTo({ left: 0, behavior: 'smooth' }); }
    else if (e.key === 'End') { e.preventDefault(); rail.scrollTo({ left: rail.scrollWidth, behavior: 'smooth' }); }
  });

  // center-active: the card closest to the rail's center grows, others shrink
  var items = Array.prototype.slice.call(rail.querySelectorAll('.nb-tl-item'));
  var raf = null;
  function markActive() {
    raf = null;
    var center = rail.getBoundingClientRect().left + rail.clientWidth / 2;
    var best = -1, bestDist = Infinity;
    items.forEach(function (it, i) {
      var r = it.getBoundingClientRect();
      var d = Math.abs((r.left + r.width / 2) - center);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    items.forEach(function (it, i) { it.classList.toggle('is-active', i === best); });
  }
  function queueActive() { if (!raf) raf = requestAnimationFrame(markActive); }
  rail.addEventListener('scroll', queueActive, { passive: true });
  addEventListener('resize', queueActive, { passive: true });
  markActive();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-accessories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-acc-card]'));
  if (!cards.length) return;

  cards.forEach(function (card) {
    // keyboard: Enter/Space flips
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (card.tagName === 'A' && e.key === 'Enter' && card.classList.contains('flipped')) return; // second Enter follows link
        e.preventDefault();
        card.classList.toggle('flipped');
      }
    });

  });

  // staggered scroll entrance
  if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    cards.forEach(function (c, i) {
      c.style.opacity = '0'; c.style.transform = 'translateY(32px)';
      c.style.transition = 'opacity .85s ease, transform .85s ease';
      c.style.transitionDelay = ((i % 4) * 0.08) + 's';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-archive"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wraps = document.querySelectorAll('.card-wrap');
  if (!wraps.length) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var d = parseInt(e.target.dataset.delay || 0, 10);
          setTimeout(function () { e.target.classList.add('visible'); }, d);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    wraps.forEach(function (w) { io.observe(w); });
  } else {
    wraps.forEach(function (w) { w.classList.add('visible'); });
  }
  // touch / keyboard flip
  document.querySelectorAll('.card-scene').forEach(function (scene) {
    scene.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches) {
        if (e.target.closest('a')) return;        // let links work
        e.preventDefault();
        scene.classList.toggle('flipped');
      }
    });
    scene.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scene.classList.toggle('flipped'); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-blog"]) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('.bl-tab');
  var cards = document.querySelectorAll('.bl-card');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var f = tab.dataset.blFilter;
      cards.forEach(function (c) {
        var tags = (c.dataset.blTags || '').split(' ');
        c.classList.toggle('is-hidden', f !== 'all' && tags.indexOf(f) === -1);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-boutiques"] && !Shopify.designMode) return;
  try {
    
(function () {
  var els = document.querySelectorAll('[data-bt-reveal]');
  if (!els.length || !('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('visible');}); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) { setTimeout(function(){ e.target.classList.add('visible'); }, 0); io.unobserve(e.target); }
    });
  }, { threshold: 0.25 });
  els.forEach(function (el, i) { el.style.transitionDelay = (i * 0.15) + 's'; io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track   = document.getElementById('col-track');
  var prevBtn = document.getElementById('col-prev');
  var nextBtn = document.getElementById('col-next');
  var counter = document.getElementById('col-current');
  if (!track) return;
  var cards = Array.prototype.slice.call(track.querySelectorAll('.col-card'));
  var total = cards.length, index = 0, busy = false, media = [];

  function initMedia() {
    cards.forEach(function (card, i) {
      var vid = card.querySelector('video.col-video');
      if (vid) {
        media[i] = { play: function () { var p = vid.play(); if (p && p.catch) p.catch(function(){}); }, pause: function () { try { vid.pause(); } catch (e) {} } };
        if (i !== 0) { try { vid.pause(); } catch (e) {} }
        return;
      }
      var iframe = card.querySelector('iframe');
      if (iframe && typeof Vimeo !== 'undefined') {
        var pl = new Vimeo.Player(iframe);
        media[i] = { play: function () { pl.play().catch(function(){}); }, pause: function () { pl.pause().catch(function(){}); } };
        if (i !== 0) pl.ready().then(function () { pl.pause().catch(function(){}); });
      }
    });
  }
  function applyStates() { cards.forEach(function (c, i) { c.classList.toggle('is-active', i === index); }); }
  function visibleCount() { if (innerWidth <= 600) return 1; if (innerWidth <= 900) return 2; return 3; }
  function maxTrack() { return Math.max(0, total - visibleCount()); }
  function translateTrack() {
    var first = cards[0]; if (!first) return;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    var step = first.offsetWidth + gap;
    var pos = Math.min(index, maxTrack());
    track.style.transform = 'translateX(' + (-pos * step) + 'px)';
  }
  function navigate(newIdx) {
    if (busy || newIdx < 0 || newIdx >= total) return;
    busy = true; var prev = index; index = newIdx;
    applyStates(); translateTrack();
    if (media[prev]) setTimeout(function(){ media[prev].pause(); }, 380);
    if (media[index]) media[index].play();
    if (counter) counter.textContent = String(index + 1);
    prevBtn.disabled = index <= 0; nextBtn.disabled = index >= total - 1;
    setTimeout(function(){ busy = false; }, 700);
  }
  prevBtn.addEventListener('click', function(){ navigate(index - 1); });
  nextBtn.addEventListener('click', function(){ navigate(index + 1); });
  addEventListener('resize', translateTrack);

  (function () {
    var vp = document.getElementById('col-viewport'); if (!vp) return;
    var startX = 0, startY = 0;
    function onStart(e){ var t = e.touches ? e.touches[0] : e; startX = t.clientX; startY = t.clientY; }
    function onEnd(e){ var t = e.changedTouches ? e.changedTouches[0] : e; var dx = t.clientX - startX, dy = t.clientY - startY; if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return; navigate(dx < 0 ? index + 1 : index - 1); }
    var section = document.querySelector('.collections');
    [vp, track, section].forEach(function(el){ if(!el) return; el.addEventListener('touchstart', onStart, {passive:true}); el.addEventListener('touchend', onEnd, {passive:true}); el.style.touchAction = 'pan-y'; });
  })();

  applyStates(); translateTrack();
  prevBtn.disabled = true; nextBtn.disabled = total <= 1;
  initMedia();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-couture-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  var acts = document.querySelectorAll('[data-ct-act]');
  if (!acts.length) return;
  if (!('IntersectionObserver' in window)) {
    acts.forEach(function (a) { a.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  acts.forEach(function (a) { io.observe(a); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-couture"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript && document.currentScript.closest ? null : null;
  function init() {
    var hasGSAP = window.gsap && window.ScrollTrigger;
    if (hasGSAP) { gsap.registerPlugin(ScrollTrigger); }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.ct-story [data-split]').forEach(function (el) {
      if (el.dataset.splitDone) return;
      el.dataset.splitDone = '1';
      var html = el.innerHTML;
      // split on <br> into lines, then words; keep <br>
      var parts = html.split(/(<br\s*\/?>)/i);
      var out = '';
      parts.forEach(function (p) {
        if (/<br/i.test(p)) { out += p; return; }
        out += p.split(/(\s+)/).map(function (w) {
          return w.trim() ? '<span class="cact-word">' + w + '</span>' : w;
        }).join('');
      });
      el.innerHTML = out;
    });

    if (!hasGSAP || reduce) return; // content already visible; no animation

    document.querySelectorAll('.ct-story [data-cact]').forEach(function (act) {
      var words = act.querySelectorAll('.cact-word');
      var revs = act.querySelectorAll('[data-rev]');
      if (words.length) gsap.set(words, { yPercent: 110, opacity: 0 });
      if (revs.length) gsap.set(revs, { y: 24, opacity: 0 });

      var tl = gsap.timeline({ scrollTrigger: { trigger: act, start: 'top 68%' } });
      if (words.length) tl.to(words, { yPercent: 0, opacity: 1, duration: 0.9, ease: 'power3.out', stagger: 0.045 });
      if (revs.length) tl.to(revs, { y: 0, opacity: 1, duration: 0.7, ease: 'power2.out', stagger: 0.12 }, words.length ? '-=0.5' : 0);

      // parallax background
      var bg = act.querySelector('[data-parallax]');
      if (bg) {
        gsap.fromTo(bg, { yPercent: -8 }, { yPercent: 8, ease: 'none',
          scrollTrigger: { trigger: act, start: 'top bottom', end: 'bottom top', scrub: true } });
      }

      // count-up
      act.querySelectorAll('[data-count]').forEach(function (num) {
        var target = parseInt(num.dataset.count, 10) || 0;
        num.textContent = '0';
        var obj = { v: 0 };
        ScrollTrigger.create({ trigger: act, start: 'top 70%', once: true, onEnter: function () {
          gsap.to(obj, { v: target, duration: 1.6, ease: 'power2.out',
            onUpdate: function () { num.textContent = Math.round(obj.v); } });
        }});
      });
    });
    ScrollTrigger.refresh();
  }

  function load() {
    if (window.gsap && window.ScrollTrigger) { init(); return; }
    // load GSAP + ScrollTrigger from CDN, then init
    var n = 0;
    function done() { n++; if (n >= 2) init(); }
    function add(src) { var t = document.createElement('script'); t.src = src; t.onload = done; t.onerror = done; document.head.appendChild(t); }
    if (!document.querySelector('script[data-gsap-core]')) {
      var a = document.createElement('script'); a.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js'; a.setAttribute('data-gsap-core',''); a.onload = function () {
        var b = document.createElement('script'); b.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js'; b.onload = init; b.onerror = init; document.head.appendChild(b);
      }; a.onerror = init; document.head.appendChild(a);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();

  // ── act rail: active tracking + click scroll + light/dark adaptation ──
  (function () {
    var rail = document.getElementById('cact-rail');
    var acts = Array.prototype.slice.call(document.querySelectorAll('.ct-story [data-cact]'));
    if (!rail || !acts.length) return;
    var nums = Array.prototype.slice.call(rail.querySelectorAll('.cact-rail-num'));
    nums.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var act = acts[parseInt(btn.dataset.actIdx, 10)];
        if (act) act.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var raf = null;
    function update() {
      raf = null;
      var mid = innerHeight / 2, best = 0, bestDist = Infinity;
      acts.forEach(function (act, i) {
        var r = act.getBoundingClientRect();
        var d = Math.abs((r.top + r.height / 2) - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      nums.forEach(function (n, i) { n.classList.toggle('active', i === best); });
      rail.classList.toggle('on-light', acts[best].classList.contains('cact--light'));
      rail.classList.toggle('visible', scrollY > innerHeight * 0.35);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(update); }
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue, { passive: true });
    update();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('.faq-tab');
  var groups = document.querySelectorAll('.faq-group');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var f = tab.dataset.faqFilter;
      groups.forEach(function (g) {
        g.classList.toggle('is-hidden', f !== 'all' && g.dataset.faqGroup !== f);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-favorites"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.fav-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var strip = document.getElementById(btn.dataset.target);
      if (!strip) return;
      var card = strip.querySelector('.fav-item');
      var step = card ? card.offsetWidth + 20 : 300;
      strip.scrollBy({ left: btn.classList.contains('fav-arrow-next') ? step * 2 : -step * 2, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  var items = Array.prototype.slice.call(document.querySelectorAll('[data-nbg-item]'));
  if (!items.length) return;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // fade-up entrance
  if ('IntersectionObserver' in window && !reduce) {
    items.forEach(function (el, i) {
      el.style.opacity = '0'; el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity .8s ease, transform .8s ease';
      el.style.transitionDelay = ((i % 4) * 0.08) + 's';
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    items.forEach(function (el) { io.observe(el); });
  }


  // drag-to-scroll (desktop mouse); taps/clicks still follow links
  var grid = document.querySelector('.nbg-grid');
  if (grid) {
    var down = false, startX = 0, startL = 0, moved = 0;
    grid.addEventListener('mousedown', function (e) {
      down = true; moved = 0; startX = e.pageX; startL = grid.scrollLeft;
      grid.classList.add('is-dragging'); e.preventDefault();
    });
    window.addEventListener('mousemove', function (e) {
      if (!down) return;
      var dx = e.pageX - startX; moved = Math.max(moved, Math.abs(dx));
      grid.scrollLeft = startL - dx;
    });
    window.addEventListener('mouseup', function () {
      if (!down) return;
      down = false;
      setTimeout(function () { grid.classList.remove('is-dragging'); }, moved > 5 ? 50 : 0);
    });
  }

  // videos: play only while visible
  var vids = document.querySelectorAll('[data-nbg-video]');
  if (vids.length && 'IntersectionObserver' in window) {
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        else { try { v.pause(); } catch (err) {} }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { vio.observe(v); });
  } else {
    vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-header"]) return;
  try {
    
(function () {
  var nav     = document.getElementById('nb-nav');
  var drawer  = document.getElementById('nb-drawer');
  var overlay = document.getElementById('nb-overlay');
  var menuBtn = document.getElementById('nb-menu-btn');
  var closeBtn= document.getElementById('nb-drawer-close');
  var spacer  = document.getElementById('nb-nav-spacer');
  if (!nav) return;

  var SCROLL = 220;
  var hasHero = !!document.querySelector('.nb-hero');
  var hovering = false, open = false;

  if (spacer && !hasHero) spacer.style.display = 'block';

  function navState() {
    nav.classList.toggle('white', !hasHero || hovering || open || window.scrollY > SCROLL);
  }
  navState();

  nav.addEventListener('mouseenter', function () { hovering = true;  navState(); });
  nav.addEventListener('mouseleave', function () { hovering = false; navState(); });
  window.addEventListener('scroll', navState, { passive: true });

  if (overlay && drawer && menuBtn && closeBtn) {
    function show() {
      open = true;
      drawer.classList.add('open'); overlay.classList.add('open');
      document.body.classList.add('nb-drawer-open');
      drawer.removeAttribute('aria-hidden');
      menuBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      navState();
      setTimeout(function () { closeBtn.focus(); }, 50);
    }
    function hide() {
      open = false;
      drawer.classList.remove('open'); overlay.classList.remove('open');
      document.body.classList.remove('nb-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      menuBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      navState(); menuBtn.focus();
    }
    menuBtn.addEventListener('click', show);
    closeBtn.addEventListener('click', hide);
    overlay.addEventListener('click', hide);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) hide(); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  var track = document.getElementById('press-track');
  if (!track) return;
  var band = track.closest('.press-band');
  var firstSeq = track.querySelector('.press-seq');
  if (!firstSeq) return;

  var SPEED = 80; // px per second — consistent regardless of how many logos

  function build() {
    // reset to a single sequence
    track.classList.remove('is-ready');
    track.style.removeProperty('--seq-width');
    track.style.removeProperty('--press-duration');
    var seqs = track.querySelectorAll('.press-seq');
    for (var k = 1; k < seqs.length; k++) seqs[k].remove();

    var seqW = firstSeq.scrollWidth;
    if (!seqW) return;
    var viewport = (band && band.offsetWidth) || window.innerWidth || 1000;

    // clone until the track spans at least 2× the viewport (so a full seq-width
    // shift never reveals empty space), minimum 2 sequences.
    var copies = Math.max(2, Math.ceil((viewport * 2) / seqW) + 1);
    for (var i = 1; i < copies; i++) track.appendChild(firstSeq.cloneNode(true));

    track.style.setProperty('--seq-width', seqW + 'px');
    track.style.setProperty('--press-duration', (seqW / SPEED) + 's');
    track.classList.add('is-ready');
  }

  build();

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); }, { passive: true });

  // rebuild once web fonts settle (text width changes once fonts load)
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var main = document.getElementById('pr-main');
  if (!main) return;
  var mainImgs = main.querySelectorAll('img');
  var thumbs = document.querySelectorAll('.pr-thumb');
  function selectImage(idx) {
    mainImgs.forEach(function (img) { img.classList.remove('is-active'); });
    thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
    if (mainImgs[idx]) mainImgs[idx].classList.add('is-active');
    if (thumbs[idx]) { thumbs[idx].classList.add('is-active'); thumbs[idx].setAttribute('aria-selected', 'true'); }
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { selectImage(parseInt(t.dataset.idx, 10)); });
    t.addEventListener('keydown', function (e) {
      var idx = parseInt(t.dataset.idx, 10);
      if (e.key === 'ArrowRight') { e.preventDefault(); var n = Math.min(thumbs.length - 1, idx + 1); selectImage(n); thumbs[n].focus(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); var p = Math.max(0, idx - 1); selectImage(p); thumbs[p].focus(); }
    });
  });
  var copyBtn = document.querySelector('.pr-share-copy');
  var flash = document.getElementById('pr-share-flash');
  if (copyBtn && flash) {
    copyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = copyBtn.dataset.shareUrl || location.href;
      var done = function () {
        copyBtn.classList.add('is-copied'); flash.classList.add('is-on');
        setTimeout(function () { copyBtn.classList.remove('is-copied'); flash.classList.remove('is-on'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(done);
      } else {
        var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (_) {} document.body.removeChild(ta); done();
      }
    });
  }
})();

  // ── zoom: desktop hover-pan + lightbox (click) ──
  (function () {
    var main = document.getElementById('pr-main');
    if (!main) return;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));
    var lb = document.getElementById('pr-lightbox');
    if (lb && lb.parentNode !== document.body) document.body.appendChild(lb);
    var lbImg = lb.querySelector('.pr-lb-img');
    var idx = 0, zoomed = false, drag = null, tx = 0, ty = 0;
    var hoverable = matchMedia('(hover: hover)').matches && innerWidth > 768;

    // desktop: hover-pan zoom on main image
    if (hoverable) {
      main.addEventListener('mouseenter', function () { main.classList.add('is-zooming'); });
      main.addEventListener('mouseleave', function () {
        main.classList.remove('is-zooming');
        var a = main.querySelector('img.is-active'); if (a) a.style.transformOrigin = '';
      });
      main.addEventListener('mousemove', function (e) {
        var a = main.querySelector('img.is-active'); if (!a) return;
        var r = main.getBoundingClientRect();
        a.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    }

    function srcFor(i) { var im = imgs[i]; return (im && (im.dataset.zoom || im.src)) || ''; }
    function activeIdx() {
      var a = main.querySelector('img.is-active');
      return a ? parseInt(a.dataset.idx, 10) || 0 : 0;
    }
    function resetZoom() { zoomed = false; tx = ty = 0; lbImg.classList.remove('zoomed'); lbImg.style.transform = ''; }
    function show(i) { idx = (i + imgs.length) % imgs.length; resetZoom(); lbImg.src = srcFor(idx); }
    function openLb() { show(activeIdx()); lb.classList.add('open'); lb.setAttribute('aria-hidden','false'); document.body.style.overflow = 'hidden'; }
    function closeLb() { lb.classList.remove('open'); lb.setAttribute('aria-hidden','true'); document.body.style.overflow = ''; }

    main.addEventListener('click', openLb);
    lb.querySelector('.pr-lb-close').addEventListener('click', closeLb);
    lb.querySelector('.pr-lb-prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.pr-lb-next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('pr-lb-stage')) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    function applyT(scale) { lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    lbImg.addEventListener('click', function (e) {
      if (drag && drag.moved) return;
      if (!zoomed) { zoomed = true; lbImg.classList.add('zoomed'); applyT(2.2); }
      else { resetZoom(); }
      e.stopPropagation();
    });
    // drag-pan when zoomed (mouse + touch)
    function start(x, y) { if (!zoomed) return; drag = { x: x - tx, y: y - ty, moved: false }; lbImg.classList.add('dragging'); }
    function move(x, y) { if (!drag) return; tx = x - drag.x; ty = y - drag.y; drag.moved = true; applyT(2.2); }
    function end() { if (drag) setTimeout(function(){ drag = null; }, 0); lbImg.classList.remove('dragging'); }
    lbImg.addEventListener('mousedown', function (e) { start(e.clientX, e.clientY); e.preventDefault(); });
    addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    addEventListener('mouseup', end);
    lbImg.addEventListener('touchstart', function (e) { if (e.touches.length===1) start(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    lbImg.addEventListener('touchmove', function (e) { if (e.touches.length===1) move(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    lbImg.addEventListener('touchend', end);
    // mobile: swipe to change image (when not zoomed)
    var sw = null;
    lb.addEventListener('touchstart', function (e) { if (!zoomed && e.touches.length===1) sw = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sw === null || zoomed) { sw = null; return; }
      var dx = e.changedTouches[0].clientX - sw; sw = null;
      if (Math.abs(dx) > 48) show(idx + (dx < 0 ? 1 : -1));
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-shop-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('shop-nav');
  if (!section) return;
  var items  = Array.prototype.slice.call(section.querySelectorAll('.shop-nav-item'));
  var images = Array.prototype.slice.call(section.querySelectorAll('.shop-nav-img'));
  var n = items.length;
  if (!n) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var targetF = 0, currentF = 0, rafId = null, lastActive = -1;

  function computeTarget() {
    var rect = section.getBoundingClientRect();
    var total = rect.height - innerHeight;
    var f = total > 0 ? (-rect.top / total) * (n - 1) : 0;
    targetF = f < 0 ? 0 : (f > n - 1 ? n - 1 : f);
  }
  function apply(f) {
    for (var i = 0; i < images.length; i++) {
      var o = 1 - Math.abs(f - i);
      o = o < 0 ? 0 : (o > 1 ? 1 : o);
      images[i].style.opacity = o;
    }
    var active = Math.round(f);
    if (active !== lastActive) {
      items.forEach(function (it, i) { it.classList.toggle('is-active', i === active); });
      lastActive = active;
    }
  }
  function loop() {
    // ease current toward target so wheel-by-wheel scroll feels buttery
    currentF += (targetF - currentF) * 0.14;
    if (Math.abs(targetF - currentF) < 0.0008) currentF = targetF;
    apply(currentF);
    rafId = Math.abs(targetF - currentF) > 0.0004 ? requestAnimationFrame(loop) : null;
  }
  function kick() {
    computeTarget();
    if (reduce) { currentF = targetF; apply(currentF); return; }
    if (!rafId) rafId = requestAnimationFrame(loop);
  }

  addEventListener('scroll', kick, { passive: true });
  addEventListener('resize', kick, { passive: true });

  // Taps on titles navigate naturally (no hijack). Tapping the image goes
  // to the ACTIVE item's page.
  var right = section.querySelector('.shop-nav-right');
  if (right) {
    right.style.cursor = 'pointer';
    right.addEventListener('click', function () {
      var idx = lastActive < 0 ? 0 : lastActive;
      var href = items[idx] && items[idx].getAttribute('href');
      if (href) window.location.href = href;
    });
  }

  computeTarget(); currentF = targetF; apply(currentF);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-silhouette"] && !Shopify.designMode) return;
  try {
    
(function () {
  // intro flip cards: mobile tap flips (first tap), keyboard Enter/Space toggles
  var cards = Array.prototype.slice.call(document.querySelectorAll('[data-sil-flip]'));
  var touch = matchMedia('(hover: none)').matches || innerWidth <= 768;
  cards.forEach(function (card) {
    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.toggle('flipped'); }
    });
    if (touch) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('a')) return; // taps on the CTA follow the link
        e.preventDefault();
        var was = card.classList.contains('flipped');
        cards.forEach(function (c) { c.classList.remove('flipped'); });
        if (!was) card.classList.add('flipped');
      });
    }
  });

  // smooth-scroll anchor CTAs (#sil-...)
  document.querySelectorAll('.sil-back-cta[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // strip arrows (same behaviour as Favorites)
  document.querySelectorAll('.sil-arrow').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var strip = document.getElementById(btn.dataset.target);
      if (!strip) return;
      var card = strip.querySelector('.sil-item');
      var step = card ? card.offsetWidth + 20 : 300;
      strip.scrollBy({ left: btn.classList.contains('sil-arrow-next') ? step * 2 : -step * 2, behavior: 'smooth' });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
